import styled from 'styled-components';
import { AdminSeatStatus } from '@/apiModels/SeatReservation';
import theme from '@/data/theme';

type Props = {
  $isDisabled: boolean;
};

const StyledAdminSeatBookingPageContent = styled.div<Props>`
  ${({ $isDisabled }) =>
    $isDisabled &&
    `
        pointer-events: none;
    `}
`;

const StyledAdminLegendWrapper = styled.div`
  display: flex;
  margin: 9px 0;
  gap: 12px;
  overflow-x: scroll;
  max-width: 75%;
  cursor: pointer;
  font-family: ${theme.fonts.primary};

  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`;

type LegendProps = {
  $status: AdminSeatStatus;
  $bookedBy?: string;
};

const StyledAdminLegend = styled.div<LegendProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  color: rgba(0, 0, 0, 0.7);
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;


  &::before {
    content: '';
    display: inline-block;
    align-items: center;
    width: 16px;
    height: 16px;
    border-radius: 3px;
    flex-shrink: 0;

    background: ${({ $status, theme }) =>
      $status === 'available'
        ? theme.colors.available
        : $status === 'revel booked'
          ? theme.colors.booked
          : $status === 'organizer booked'
            ? theme.colors.primary
            : $status === 'disabled'
              ? theme.colors.badgeBgGreyColor
              : theme.colors.hold};
  }
  }
`;

export { StyledAdminSeatBookingPageContent, StyledAdminLegendWrapper, StyledAdminLegend };
